module.exports = __webpack_public_path__ + "static/media/sectors-our-readers-come-from-img.49d08e8e.png";